// Active Map Content

attachEvent('.under-construction .region-map__area', 'click', (event) => {
  const selectedArea = event.target.closest('.region-map__area');
  const areaId = selectedArea.getAttribute('id');
  const parentEle = selectedArea.closest('.under-construction');

  parentEle.querySelectorAll('.region-map__area').forEach((el) => el.classList.remove('is-active'));
  parentEle.querySelectorAll('[data-region-content]').forEach((el) => el.classList.remove('is-active'));

  selectedArea.classList.add('is-active');
  parentEle.querySelector(`[data-region-content="${areaId}"]`)?.classList.add('is-active');
});
